import { useMemo } from 'react';

import { RolloutEnum } from '@lib/resources/types';
import configService from '@lib/services/configService';

import usePermissions from './usePermissions';

export default function useSitePatient() {
  const { hasAccessToProduct } = usePermissions();

  const sitePatient = useMemo(() => {
    if (hasAccessToProduct(RolloutEnum.NextyPatient)) {
      return configService.getSiteNextyPatient();
    }
    return configService.getSitePatient();
  }, [hasAccessToProduct]);

  return sitePatient as string;
}
